import Popover from "./popover.component";

export default Popover;
